module.exports = __webpack_public_path__ + "img/dots-circle.ee77da58.svg";